import React, { Component } from "react";
import "./AddFeeDetails.scss";
import "react-toastify/dist/ReactToastify.css";
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import Axios from "axios";
import { BaseUrl } from "../../../Environment";
import { getSecureItem } from "../../../utilsFunctions";
import Sidebar from "../../sidebar/sidebar";
import { companylogo } from "../../../assets/images";

import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    RadioGroup,
    TextField,
    MenuItem,
    FormControl,
    FormControlLabel,
    Radio,
    FormLabel,
} from "@mui/material";

class AddFeeDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            feeList: [],
            showModal: false,
            isEdit: false,
            editIndex: null,
            form: {
                feeId: null,
                name: "",
                calculation: "",
                category: "",
                value: "",
                status: "Active",
                feeAccountingType: "",
                companyId: "",
            },
        };
    }

    componentDidMount() {
        this.getAllFeeDetails();
    }

    getAllFeeDetails = async () => {
        try {
            const companyId = getSecureItem("loggedinUserCompany");
            const headers = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getSecureItem("token"),
            };

            const result = await Axios.get(
                `${BaseUrl}/feeDetails/getFeeDetails/${companyId}`,
                { headers },
            );

            this.setState({ feeList: result.data || [] });
        } catch (err) {
            console.error("Error loading Fee Details:", err);
            this.setState({ feeList: [] });
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            form: { ...prev.form, [name]: value },
        }));
    };

    editFee = (item, index) => {
        this.setState({
            showModal: true,
            isEdit: true,
            editIndex: index,
            form: { ...item },
        });
    };

    deleteFee = async (item, index) => {
        if (!window.confirm("Are you sure you want to delete this fee?")) return;

        try {
            const headers = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getSecureItem("token"),
            };

            await Axios.delete(
                `${BaseUrl}/feeDetails/deleteFeeDetails/${item.feeId}`,
                { headers },
            );

            const updated = [...this.state.feeList];
            updated.splice(index, 1);

            this.setState({ feeList: updated });
        } catch (err) {
            console.error("Delete failed:", err);
            alert("Delete failed");
        }
    };

    submitFee = async () => {
        const { form, isEdit, editIndex } = this.state;
        const companyId = getSecureItem("loggedinUserCompany");

        if (!form.name || !form.calculation || !form.category || !form.value) {
            alert("Please fill all fields");
            return;
        }

        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + getSecureItem("token"),
        };

        try {
            if (isEdit) {
                await Axios.put(
                    `${BaseUrl}/feeDetails/putFeeDetails`,
                    { ...form, companyId },
                    { headers },
                );

                const updated = [...this.state.feeList];
                updated[editIndex] = { ...form };

                this.setState({
                    feeList: updated,
                    showModal: false,
                    isEdit: false,
                });
            } else {
                await Axios.post(
                    `${BaseUrl}/feeDetails/postFeeDetails`,
                    {
                        name: form.name,
                        calculation: form.calculation,
                        category: form.category,
                        value: form.value,
                        status: form.status,
                        feeAccountingType: form.feeAccountingType,
                        companyId,
                    },
                    { headers },
                );

                this.getAllFeeDetails();

                this.setState({
                    showModal: false,
                });
            }
        } catch (err) {
            console.error("Submit failed:", err);
            alert("Save failed");
        }
    };

    render() {
        const { feeList, showModal, form, isEdit } = this.state;
        const { t } = this.props;

        return (
            <>
                <Sidebar />

                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="10px 100px"
                >
                    <img src={companylogo} alt="logo" />
                </Stack>

                <div className="fee-page">
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        padding="10px 20px 10px 100px"
                        className="fee-header"
                    >
                        <div style={{ flex: 1 }}></div>

                        <h2 style={{ flex: 1, textAlign: "center", margin: 0 }}>
                            {t("Fee Details")}
                        </h2>

                        <div style={{ flex: 1, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: "#00D95E",
                                    color: "#fff",
                                    padding: "8px 18px",
                                    borderRadius: "6px",
                                    fontWeight: "bold",
                                }}
                                onClick={() =>
                                    this.setState({
                                        showModal: true,
                                        isEdit: false,
                                        form: {
                                            feeId: null,
                                            name: "",
                                            calculation: "",
                                            category: "",
                                            value: "",
                                            status: "Active",
                                            feeAccountingType: "",
                                            companyId: getSecureItem("loggedinUserCompany"),
                                        },
                                    })
                                }
                            >
                                + {t("Add Loan Fee")}
                            </Button>
                        </div>
                    </Stack>

                    <Stack
                        className="feedetailspage"
                        spacing={1}
                        padding="10px 20px 10px 100px"
                    >
                        <Card style={{ marginTop: "10px" }}>
                            <div className="tableLaylout">
                                <Table className="table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Sr. No</TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Calculation</TableCell>
                                            <TableCell>Category</TableCell>
                                            <TableCell>Value</TableCell>
                                            <TableCell>Accounting Type</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Actions</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {feeList.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell>{item.calculation}</TableCell>
                                                <TableCell>{item.category}</TableCell>
                                                <TableCell>{item.value}</TableCell>
                                                <TableCell>
                                                    {item.feeAccountingType === "revenue"
                                                        ? "Revenue (P/L)"
                                                        : "Payable / Tax"}
                                                </TableCell>
                                                <TableCell>{item.status}</TableCell>

                                                <TableCell>
                                                    <Stack direction="row" spacing={1}>
                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: "#007bff",
                                                                color: "#fff",
                                                            }}
                                                            onClick={() => this.editFee(item, index)}
                                                        >
                                                            Edit
                                                        </Button>

                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: "#d9534f",
                                                                color: "#fff",
                                                            }}
                                                            onClick={() => this.deleteFee(item, index)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Card>
                    </Stack>

                    {showModal && (
                        <Dialog
                            open={showModal}
                            onClose={() => this.setState({ showModal: false })}
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle>{isEdit ? "Edit Fee" : "Add Fee"}</DialogTitle>

                            <DialogContent dividers>
                                <div className="form-field">
                                    <TextField
                                        fullWidth
                                        label="Name"
                                        name="name"
                                        value={form.name}
                                        onChange={this.handleChange}
                                        size="small"
                                    />
                                </div>

                                <div className="form-field" style={{ marginTop: "18px" }}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Calculation"
                                        name="calculation"
                                        value={form.calculation}
                                        onChange={this.handleChange}
                                        size="small"
                                    >
                                        <MenuItem value="Fixed">Fixed</MenuItem>
                                        <MenuItem value="Percentage">Percentage</MenuItem>
                                    </TextField>
                                </div>

                                <div className="form-field" style={{ marginTop: "18px" }}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Category"
                                        name="category"
                                        value={form.category}
                                        onChange={this.handleChange}
                                        size="small"
                                    >
                                        <MenuItem value="Deductable Fee">Deductable Fee</MenuItem>
                                        <MenuItem value="Add-On Fee">Add-On Fee</MenuItem>
                                    </TextField>
                                </div>

                                <div className="form-field" style={{ marginTop: "18px" }}>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label="Value"
                                        name="value"
                                        value={form.value}
                                        onChange={this.handleChange}
                                        size="small"
                                    />
                                </div>

                                <div className="form-field" style={{ marginTop: "18px" }}>
                                    <FormControl>
                                        <FormLabel
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                marginBottom: "6px",
                                                fontFamily: "Lato",
                                            }}
                                        >
                                            Accounting Type
                                        </FormLabel>

                                        <RadioGroup
                                            row
                                            name="feeAccountingType"
                                            value={form.feeAccountingType}
                                            onChange={this.handleChange}
                                        >
                                            <FormControlLabel
                                                value="revenue"
                                                control={<Radio />}
                                                label="Revenue (P/L)"
                                                sx={{
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "13px",
                                                        fontFamily: "Lato",
                                                        whiteSpace: "nowrap",
                                                    },
                                                }}
                                            />

                                            <FormControlLabel
                                                value="payable"
                                                control={<Radio />}
                                                label="Payable / Tax"
                                                sx={{
                                                    "& .MuiFormControlLabel-label": {
                                                        fontSize: "13px",
                                                        fontFamily: "Lato",
                                                        whiteSpace: "nowrap",
                                                    },
                                                }}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                <div className="form-field" style={{ marginTop: "18px" }}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Status"
                                        name="status"
                                        value={form.status}
                                        onChange={this.handleChange}
                                        size="small"
                                    >
                                        <MenuItem value="Active">Active</MenuItem>
                                        <MenuItem value="Inactive">Inactive</MenuItem>
                                    </TextField>
                                </div>
                            </DialogContent>

                            <DialogActions>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={() =>
                                        this.setState({ showModal: false, isEdit: false })
                                    }
                                >
                                    Cancel
                                </Button>

                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={this.submitFee}
                                >
                                    {isEdit ? "Update" : "Save"}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </div>
            </>
        );
    }
}

export default withNamespaces()(withRouter(AddFeeDetails));
